import React, { useState, useEffect, Fragment } from "react";
import { DiagPayment, DiagQRCode } from "../../component/dialog-box";
import Loader from "./loader";
// import manager from "../../component/manager";
import config from "../../component/config";
import crypto from "crypto-js";
import { pgw } from "../../component/api";
import { toast } from "../../component/component";

const isEnabled = (opt, key) => {
  if (opt) {
    const item = opt.filter((_) => _.type === key);
    if (item.length > 0) return item[0].enabled;
    else return false;
  }
  return false;
};

// const paymentOptions = (opt, key) => {
//   if (opt) {
//     const item = opt.filter((_) => _.type === key);
//     if (item.length > 0) return item[0];
//     else return { withConvinienceFee: false, convenienceFee: 0 };
//   }
//   return { withConvinienceFee: false, convenienceFee: 0 };
// };

const PaymentDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [qrCode, setQrCode] = useState();

  const paymentOptions = async () => {
    await pgw
      .get(`/online/settings/Payment Options`)
      .then((res) => {
        const { data } = res.data;
        setOptions(data);
      })
      .catch((e) => {
        toast("Error encountered", "", "warning");
      });
  };

  const paymayaPayment = async (params) => {
    await pgw
      .post("/paymaya", params)
      .then((res) => {
        const { data } = res.data;
        window.location = data.redirectUrl;
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast("Error encountered!", "", "error");
      });
  };

  const multisysPayment = async (params) => {
    await pgw
      .post("/multisys", params)
      .then((res) => {
        const { data } = res.data;
        window.open(data.url, "_blank");
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast("Error encountered!", "", "error");
      });
  };

  const unionbankPayment = async (params) => {
    await pgw
      .post("/union-bank/checkout", params)
      .then((res) => {
        const { data } = res.data;
        window.location = data;
      })
      .catch((err) =>
        this.setState({ loading: false }, () =>
          toast("Error encountered!", "", "error")
        )
      );
  };

  const starpayPayment = async (params) => {
    await pgw
      .post("/starpay/check-sum", params)
      .then((res) => {
        const { success, data, message } = res.data;
        if (success) {
          setQrCode(data.qrCode);
        } else toast(message, null, "warning");
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast("Error encountered!", "", "error");
        console.error(err);
      });
  };

  useEffect(() => {
    if (qrCode) document.getElementById("open-qrcode").click();
  }, [qrCode]);

  // const myegPayment = async (params) => {
  //   await pgw
  //     .post("/myeg", params)
  //     .then(async (res) => {
  //       var w = window.open("", "about:blank");
  //       w.document.write(res.data);
  //       w.document.close();
  //       w.focus();
  //     })
  //     .catch((err) =>
  //       this.setState({ loading: false }, () =>
  //         toast("Error encountered!", "", "error")
  //       )
  //     );
  // };

  const dataPayMayaMultiSys = (model, billing) => {
    return {
      billing: {
        type: "",
        reference_no: billing.bill_no,
      },
      totalAmount: {
        value: billing.total_amount,
        currency: "PHP",
        details: {
          discount: 0,
          serviceCharge: 0,
          shippingFee: 0,
          tax: 0,
          subtotal: billing.total_amount,
        },
      },
      buyer: {
        firstName: model.first_name,
        lastName: model.last_name,
        contact: {
          phone: model.mobile,
          email: model.email,
        },
        shippingAddress: {
          firstName: model.first_name,
          lastName: model.last_name,
          phone: model.name,
          email: model.email,
          line1: "",
          line2: "",
          city: "",
          zipCode: "",
          countryCode: "",
          shippingType: "",
        },
        billingAddress: {
          line1: "San Antonio Ave",
          line2: "San Antonio",
          city: "Parañaque City",
          zipCode: "1700",
          countryCode: "PH",
        },
      },
      items: [],
    };
  };

  const dataUnionBank = (model, billing) => {
    const opt = options.find((_) => _.type === "union-bank");
    const { type } = props;
    return {
      bill_no: billing.bill_no,
      total_amount:
        billing.total_amount +
        (opt.withConvinienceFee ? opt.convenienceFee : 0),
      bill_type:
        type === "misc"
          ? "Miscellaneous"
          : type === "rpt"
          ? "Real Property"
          : "",
      name: `${model.first_name} ${model.last_name}`,
      email: model.email,
      mobile: model.mobile,
    };
  };

  const dataStarpay = (model, billing) => {
    const opt = options.find((_) => _.type === "starpay");
    const { type } = props;
    const { bill_no, total_amount } = billing;
    const { first_name, last_name, email, mobile } = model;

    return {
      billing: {
        reference_no: bill_no,
        type:
          type === "misc"
            ? "Miscellaneous"
            : type === "rpt"
            ? "Real Property"
            : "",
      },

      total_amount:
        total_amount + (opt.withConvinienceFee ? opt.convenienceFee : 0),

      name: `${first_name} ${last_name}`,
      email,
      mobile,
    };
  };

  const proceedPayment = (model, type, fn) => {
    const data = sessionStorage.getItem("data");
    const billing = JSON.parse(
      crypto.AES.decrypt(data, config.secretKey).toString(crypto.enc.Utf8)
    );
    let params;
    const opt = paymentOptions(options, type);

    switch (type) {
      case "paymaya":
        setLoading(true);
        params = dataPayMayaMultiSys(model, billing);

        switch (props.type) {
          case "misc":
            // paymaya - miscellaneous
            billing.vwBillingDetails.forEach((item) => {
              params.billing.type = "Miscellaneous";
              params.items.push({
                name: item.description,
                quantity: item.qty,
                code: item.code,
                description: item.description,
                amount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
                totalAmount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
              });
            });

            setTimeout(async () => {
              await paymayaPayment(params).then(() => setLoading(false));
            }, 500);
            break;

          case "rpt":
            // paymaya - real property
            billing.billingDetails.forEach((item) => {
              params.billing.type = "Real Property";
              params.items.push({
                name: `RPT Payment - ${item.arp} ${item.year} ${item.qtr_from}-${item.qtr_to}`,
                quantity: 1,
                code: `${item.arp} ${item.year} ${item.qtr_from}-${item.qtr_to}`,
                description: `real property payment for tax year ${item.year}`,
                amount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
                totalAmount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
              });
            });

            setTimeout(async () => {
              await paymayaPayment(params).then(() => setLoading(false));
            }, 500);

            break;

          default:
            setLoading(false);
            break;
        }
        break;

      case "multi-sys":
        setLoading(true);
        params = dataPayMayaMultiSys(model, billing);

        switch (props.type) {
          case "misc":
            // paymaya - miscellaneous
            billing.vwBillingDetails.forEach((item) => {
              params.billing.type = "Miscellaneous";
              params.items.push({
                name: item.description,
                quantity: item.qty,
                code: item.code,
                description: item.description,
                amount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
                totalAmount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
              });
            });

            setTimeout(async () => {
              await multisysPayment(params).then(() => setLoading(false));
            }, 500);
            break;

          case "rpt":
            // paymaya - real property
            billing.billingDetails.forEach((item) => {
              params.billing.type = "Real Property";
              params.items.push({
                name: `RPT Payment - ${item.arp} ${item.year} ${item.qtr_from}-${item.qtr_to}`,
                quantity: 1,
                code: `${item.arp} ${item.year} ${item.qtr_from}-${item.qtr_to}`,
                description: `real property payment for tax year ${item.year}`,
                amount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
                totalAmount: {
                  value: item.total,
                  details: {
                    discount: 0,
                    serviceCharge: 0,
                    shippingFee: 0,
                    tax: 0,
                    subtotal: item.total,
                  },
                },
              });
            });

            setTimeout(async () => {
              await multisysPayment(params).then(() => setLoading(false));
            }, 500);

            break;

          default:
            setLoading(false);
            break;
        }
        break;

      case "myeg":
        switch (this.props.type) {
          case "misc":
            let items = null;
            this.props.data.vwBillingDetails.map(
              (i) => (items = `${items}, ${i.description}`)
            );
            params = {
              amount: this.props.data.total_amount,
              currency: "PHP",
              customer_email: model.email,
              customer_name: `${model.first_name} ${model.last_name}`,
              order_no: this.props.data.bill_no,
              product_description: `Misc Payment for bill number ${this.props.data.bill_no}`,
            };

            setTimeout(async () => {
              await this.myegPayment(params).then(() =>
                this.setState({ loading: false })
              );
            }, 500);
            break;

          case "rpt":
            params = {
              amount: this.props.data.total_amount,
              currency: "PHP",
              customer_email: model.email,
              customer_name: `${model.first_name} ${model.last_name}`,
              order_no: this.props.data.bill_no,
              product_description: `RPT Payment - ${this.props.data.remarks}`,
            };

            setTimeout(async () => {
              await this.myegPayment(params).then(() =>
                this.setState({ loading: false })
              );
            }, 500);
            break;

          default:
            break;
        }

        break;

      case "union-bank":
        setLoading(true);
        params = dataUnionBank(model, billing);
        params.options = opt;

        setTimeout(async () => {
          await unionbankPayment(params)
            .then(() => setLoading(false))
            .catch(() => {
              setLoading(false);
              toast("Error Encountered", null, "warning");
            });
        }, 500);
        break;

      case "starpay":
        setLoading(true);
        params = dataStarpay(model, billing);
        params.options = opt;

        setTimeout(async () => {
          await starpayPayment(params)
            .then(() => fn(false))
            .then(() => setLoading(false))
            .catch(() => {
              setLoading(false);
              toast("Error Encountered", null, "warning");
            });
        }, 500);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    paymentOptions();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="w-full py-5">
        <div className="text-orange-500 font-bold">Payment Options</div>
        <div className="h-12 flex gap-3 mx-auto mt-3">
          {isEnabled(options, "paymaya") && (
            <DiagPayment
              proceed={proceedPayment}
              pgw="paymaya"
              options={options}
            />
          )}
          {isEnabled(options, "myeg") && (
            <DiagPayment
              proceed={proceedPayment}
              pgw="myeg"
              options={options}
            />
          )}
          {isEnabled(options, "union-bank") && (
            <DiagPayment
              proceed={proceedPayment}
              pgw="union-bank"
              options={options}
            />
          )}
          {isEnabled(options, "multi-sys") && (
            <DiagPayment
              proceed={proceedPayment}
              pgw="multi-sys"
              options={options}
            />
          )}
          {isEnabled(options, "starpay") && (
            <DiagPayment
              proceed={proceedPayment}
              pgw="starpay"
              options={options}
            />
          )}
        </div>
        <DiagQRCode data={qrCode} />
      </div>
    </>
  );
};

export default PaymentDetails;
